import React from "react";
import theme from "theme";
import { Theme, Link, Box, Section, Text, Image, LinkBox, Hr, Input, Button, Structure, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { BsPhone, BsEnvelope, BsMap } from "react-icons/bs";

//import LightGallery from 'lighggallery/react';
//import lgZoom from 'lightgallery/plugins/zoom';
//import lgThumbnail from 'lightgallery/plugins/thumbnail';
//import { LightGallery as ILightGallery } from 'lightgallery/lightgallery';

//import { LightGallerySettings } from 'lightgallery/lg-settings';
//import lgVideo from 'lightgallery/plugins/video';

import Gallery from './gallery.js'

export default (() => {
  return <Theme theme={theme}>
    <GlobalQuarklyPageStyles pageUrl={"index"} />
    <Helmet>
      <title>
        Dvůr U Mlýna
      </title>
      <meta name={"description"} content={"Jsme malé rodinné hospodářství s útulným ubytováním. Najdete u nás nejen výborné domácí produkty, ale také možnost odpočinku v malebném údolí potoka Bítýšky."} />
      <meta property={"og:title"} content={"Dvůr U Mlýna"} />
      <meta property={"og:description"} content={"Jsme malé rodinné hospodářství s útulným ubytováním. Najdete u nás nejen výborné domácí produkty, ale také možnost odpočinku v malebném údolí potoka Bítýšky."} />
      <meta property={"og:image"} content={"https://uploads.quarkly.io/615c316435c5c8001f775568/images/wedding%20template.png?v=2021-10-05T11:13:30.358Z"} />
      <link rel={"shortcut icon"} href={"https://uploads.quarkly.io/615c316435c5c8001f775568/images/openmoji_couple-with-heart32.png?v=2021-10-05T11:11:03.451Z"} type={"image/x-icon"} />
    </Helmet>
    <Section padding="47px 0 47px 0">
      <Override slot="SectionContent" flex-direction="row" />
      <Box
        width="40%"
        sm-width="50%"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
      >
        <Link
          href="/"
          font="400 28px/1.5 --fontFamily-googleMarcellus"
          color="--primary"
          text-decoration-line="initial"
          md-font="400 24px/1.5 --fontFamily-googleMarcellus"
        >
          Dvůr U Mlýna
        </Link>
      </Box>
      <Box
        empty-border-width="1px"
        width="60%"
        justify-content="flex-end"
        empty-min-height="64px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        display="flex"
        align-items="center"
        empty-min-width="64px"
      >
        <Components.QuarklycommunityKitMobileSidePanel>
          <Override slot="Button Text" md-color="--primary" md-font="--lead" />
          <Override slot="Button Text :closed">
            Menu
          </Override>
          <Override slot="Button Icon" md-color="--primary" />
          <Override slot="Content" background="none" padding="0px 0px 0px 0px" />
          <Override slot="Button Text :open">
            Menu
          </Override>
          <Box
            justify-content="space-between"
            md-flex-direction="column"
            md-align-items="center"
            md-background="--color-pageBg"
            md-padding="20px 0px 20px 0px"
            display="flex"
          >
            <Link
              transition="opacity 0.3s ease-in-out 0s"
              hover-opacity=".8"
              href="#onas"
              color="--darkL2"
              font="--lead"
              text-decoration-line="initial"
              padding="8px 8px 8px 8px"
            >
              O nás
            </Link>
            <Link
              color="--darkL2"
              font="--lead"
              text-decoration-line="initial"
              padding="8px 8px 8px 8px"
              transition="opacity 0.3s ease-in-out 0s"
              hover-opacity=".8"
              href="#ubytovani"
            >
              Ubytování
            </Link>
            <Link
              href="#galerie"
              color="--darkL2"
              font="--lead"
              text-decoration-line="initial"
              padding="8px 8px 8px 8px"
              transition="opacity 0.3s ease-in-out 0s"
              hover-opacity=".8"
            >
              Galerie
            </Link>
            <Link
              href="#kontakty"
              color="--darkL2"
              font="--lead"
              text-decoration-line="initial"
              padding="8px 8px 8px 8px"
              transition="opacity 0.3s ease-in-out 0s"
              hover-opacity=".8"
            >
              Kontakty
            </Link>
          </Box>
        </Components.QuarklycommunityKitMobileSidePanel>
      </Box>
    </Section>
    <Section padding="68px 0 68px 0" md-padding="0px 0 28px 0">
      <Override slot="SectionContent" md-flex-direction="column" flex-direction="row" />
      <Box
        empty-border-width="1px"
        empty-border-color="LightGray"
        md-position="relative"
        lg-margin="0px 0px 0px 0px"
        empty-min-width="64px"
        width="50%"
        flex-direction="column"
        padding="50px 60px 100px 0px"
        lg-padding="0px 0px 0px 0px"
        empty-border-style="solid"
        margin="0px 60px 0px 0px"
        display="flex"
        align-items="flex-start"
        empty-min-height="64px"
        justify-content="space-between"
        md-width="100%"
      >
        <Text
          md-width="80%"
          sm-width="100%"
          margin="0px 0px 40px 0px"
          font="--headline1"
          color="--primary"
          lg-font="normal 500 50px/1.3 &quot;Marcellus&quot;, serif"
          lg-margin="0px 0px 16px 0px"
          md-font="normal 500 40px/1.3 &quot;Marcellus&quot;, serif"
          text-align="left"
          sm-font="--headline1"
        >
          Dvůr U Mlýna
        </Text>
        <Text margin="0px 0px 0px 0px" color="--green" font="--headline2">
          Kde se čas zpomalí, kraj dýchá klidem a vzduch voní obilím.
        </Text>
        <Text
          margin="50px 0px 60px 0px"
          font="--lead"
          color="--darkL1"
          md-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif"
          md-margin="0px 0px 32px 0px"
        >
          Jsme malé rodinné hospodářství s útulným ubytováním. Najdete u nás nejen výborné domácí produkty, ale také možnost odpočinku v malebném údolí potoka Bítýšky.{" "}
        </Text>
      </Box>
      <Box
        empty-min-width="64px"
        empty-border-style="solid"
        md-margin="0px 0px 0px 0px"
        md-width="100%"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-color="LightGray"
        width="50%"
        margin="0px 0px 0px 60px"
      >
        <Image
          src="/index/d1.JPG"
          object-fit="cover"
          lg-min-height="481px"
          max-height="616px"
          width="100%"
          object-position="0% 70%"
          md-max-height="410px"
          md-min-height="none"
          md-margin="0px 0px 150px 0px"
          sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
        />
      </Box>
    </Section>
    <Section id="onas" padding="68px 0 68px 0" md-padding="0px 0 28px 0">
      <Override slot="SectionContent" flex-direction="row" md-flex-direction="column" />
      <Box
        empty-min-width="64px"
        align-items="flex-start"
        lg-padding="0px 0px 0px 0px"
        md-width="100%"
        empty-min-height="64px"
        empty-border-width="1px"
        margin="0px 60px 0px 0px"
        display="flex"
        md-position="relative"
        lg-margin="0px 0px 0px 0px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="50%"
        flex-direction="column"
        justify-content="space-between"
      >
        <Image
          width="100%"
          object-fit="cover"
          margin="0px 0px 40px 0px"
          min-height="557px"
          md-max-height="388px"
          md-min-height="none"
          src="/index/ch1.jpg"
        />
        <Text
          margin="0px 0px 40px 0px"
          font="--headline2"
          color="--primary"
          lg-font="normal 500 32px/1.3 &quot;Marcellus&quot;, serif"
          lg-margin="0px 0px 16px 0px"
          md-font="normal 500 28px/1.3 &quot;Marcellus&quot;, serif"
        >
          Najděte u nás odpočinek
        </Text>
        <Text
          margin="0px 0px 0px 0px"
          font="--lead"
          color="--darkL2"
          md-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif"
          md-margin="0px 0px 40px 0px"
        >
          Hledáte místo, kde si odpočinout od rušného života? Hledáte místo, kde se zastaví čas a Vy můžete zpomalit a načerpat energii? U nás si zaručeně odpočinete. Čeká na Vás ubytování v krásném údolí s výhledem do lesů a na pasoucí se daňky.
        </Text>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        md-width="100%"
        md-margin="0px 0px 0px 0px"
        empty-min-width="64px"
        width="50%"
        margin="0px 0px 0px 60px"
        empty-min-height="64px"
      >
        <Text
          font="--headline2"
          color="--green"
          lg-font="normal 500 32px/1.3 &quot;Marcellus&quot;, serif"
          md-font="normal 500 28px/1.3 &quot;Marcellus&quot;, serif"
          lg-margin="0px 0px 16px 0px"
          margin="0px 0px 40px 0px"
        >
          Z přírody přímo na Váš stůl
        </Text>
        <Text md-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif" margin="0px 0px 40px 0px" font="--lead" color="--darkL2">
          Kde jinde najít výborné produkty, které přinášejí teplo domova, než u nás. Na našem hospodářství ctíme zásady ekologického zěmědělství, šetrně obhospodařujeme půdu a se zvířaty jednáme s respektem a láskou. Zvířata žijí v klidu, v přirozených podmínkách. Všechna mají jména. Včelám prospívá vyvážené okolí tvořené zelenými lesy, pestrými poli a květnamými loukami. To vše tvoří výjimečné podmínky pro dokonalé produkty.{" "}
        </Text>
        <Image
          md-min-height="none"
          src="/index/v9.jpg"
          width="100%"
          object-fit="cover"
          object-position="0% 70%"
          min-height="400px"
          md-max-height="329px"
        />
      </Box>
    </Section>
    <Section background="--color-sectionBg" padding="80px 0 80px 0" md-padding="40px 0 40px 0">
      <Text
        margin="0px 0px 40px 20%"
        font="--headline2"
        color="--green"
        lg-font="normal 500 32px/1.3 &quot;Marcellus&quot;, serif"
        lg-margin="0px 0px 24px 15%"
        md-margin="0px 0px 24px 0px"
        text-align="right"
      >
        Místo, které nadchne
      </Text>
      <Image
        object-fit="cover"
        margin="0px 0px 40px 0px"
        max-height="600px"
        lg-max-height="322px"
        lg-margin="0px 0px 24px 0px"
        src="/index/s1.jpg"
        width="100%"
        sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
      />
      <Text margin="0px 0px 0px 0px" font="--lead" color="--darkL2" max-width="540px">
        Naše hospodářství najdete u Maňkova mlýna v lese Zlámance u Osové Bítýšky. Rozkládá se v malebném údolí a je lemované zelenými lesy. Za mlýnem najdete samotný dvůr s hospodářským zázemím, včelínem a oborou s daňky. Dále po proudu potoka se rozkládají pastviny, kde najdete pasoucí se ovce, koně a krávy.
      </Text>
    </Section>
    <Section padding="160px 0 50px 0" lg-padding="100px 0 50px 0" sm-padding="40px 0 40px 0" md-padding="40px 0 50px 0">
      <Override slot="SectionContent" flex-direction="row" flex-wrap="wrap" />
      <Box
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="100%"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
      >
        <Text id="ubytovani" font="--headline2" color="--primary" margin="0px 0px 20px 0px" lg-font="normal 500 32px/1.3 &quot;Marcellus&quot;, serif">
          Co vše u nás najdete?
        </Text>
        <Text
          lg-margin="0px 0px 40px 0px"
          font="--lead"
          color="--darkL2"
          margin="0px 0px 80px 0px"
          width="50%"
          lg-width="65%"
          sm-width="100%"
        />
        <Box
          empty-border-color="LightGray"
          display="flex"
          margin="0px 0px 64px 0px"
          md-flex-direction="column"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
        >
          <Box
            empty-border-color="LightGray"
            md-border-style="none"
            empty-min-height="64px"
            empty-border-width="1px"
            width="55%"
            margin="0px 74px 0px 0px"
            empty-border-style="solid"
            border-width="0px 0px 1px 0px "
            border-style="solid"
            md-width="100%"
            empty-min-width="64px"
            border-color="rgba(224, 89, 119, 0.5)"
            lg-margin="0px 32px 0px 0px"
            md-margin="0px 32px 30px 0px"
          >
            <Image
              max-height="288px"
              lg-min-height="308px"
              lg-max-height="none"
              md-margin="0px 0px 0px 0px"
              src="/index/chcrop.jpg"
              width="100%"
              object-fit="cover"
              margin="0px 0px 40px 0px"
              sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
            />
          </Box>
          <Box
            padding="0px 0px 0px 0px"
            border-width="0px 0px 1px 0px "
            border-style="solid"
            empty-min-height="64px"
            empty-border-color="LightGray"
            width="45%"
            border-color="rgba(224, 89, 119, 0.5)"
            md-width="100%"
            empty-min-width="64px"
            empty-border-width="1px"
            empty-border-style="solid"
          >
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Chata
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--darkL2">
              Ubytování s výhledem na pasoucí se daňky
            </Text>
            <Text margin="0px 0px 40px 0px" font="--lead" color="--darkL2" lg-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif">
              Hledáte místo, kde si dokonale odpočinete a načerpáte nové síly? Pak zamiřte k nám. Nabízíme ubytování v nové chatě na našem hospodářství. Chata skýtá obývací pokoj s prostorným kuchyňským koutem a ložnici s možností ubytování až čtyř osob. K chatě patří prostorná zahrada s pergolou a ohništěm. V okolí najdete mnoho možností výletů do přírody pěšky i na kole. Dále můžete navštívit Údolí Bílého potoka, zámek Náměšť nad Oslavou a mnoho dalších skvělých míst. V rámci hospodářství nabízíme jízdu na koni, nebo rybářskou povolenku.
            </Text>
          </Box>
        </Box>
        <Box
          empty-border-style="solid"
          empty-border-color="LightGray"
          display="flex"
          margin="0px 0px 64px 0px"
          md-flex-direction="column"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
        >
          <Box
            empty-border-width="1px"
            empty-border-style="solid"
            border-color="rgba(224, 89, 119, 0.5)"
            lg-margin="0px 32px 0px 0px"
            empty-border-color="LightGray"
            md-border-style="none"
            empty-min-width="64px"
            empty-min-height="64px"
            width="55%"
            border-width="0px 0px 1px 0px "
            md-width="100%"
            border-style="solid"
            margin="0px 74px 0px 0px"
            md-margin="0px 32px 30px 0px"
          >
            <Image
              src="/index/kcrop.JPG"
              width="100%"
              object-fit="cover"
              margin="0px 0px 40px 0px"
              max-height="288px"
              object-position="50% 50%"
              lg-min-height="308px"
              md-margin="0px 0px 0px 0px"
            />
          </Box>
          <Box
            empty-border-color="LightGray"
            width="45%"
            border-width="0px 0px 1px 0px "
            border-style="solid"
            border-color="rgba(224, 89, 119, 0.5)"
            empty-min-width="64px"
            empty-min-height="64px"
            empty-border-width="1px"
            empty-border-style="solid"
            padding="0px 0px 0px 0px"
            md-width="100%"
          >
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Krávy Dexter
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--darkL2">
              Malé plemeno se zdravým masem výborné chuti
            </Text>
            <Text color="--darkL2" lg-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif" margin="0px 0px 40px 0px" font="--lead">
              Na hospodářství chováme stádo krav malého plemena, Dexter. Je to malé evropské plemeno, které má výborné vlastnosti. Mezi ně patří i zdravé a výživově bohaté maso. Všechna zvířata u nás mají jména. V našem stádečku proto najdete Dory, Růženku a Ferdu.
            </Text>
          </Box>
        </Box>
        <Box
          empty-border-style="solid"
          empty-border-color="LightGray"
          display="flex"
          margin="0px 0px 64px 0px"
          md-flex-direction="column"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
        >
          <Box
            empty-border-width="1px"
            empty-border-style="solid"
            border-color="rgba(224, 89, 119, 0.5)"
            lg-margin="0px 32px 0px 0px"
            empty-border-color="LightGray"
            md-border-style="none"
            empty-min-width="64px"
            empty-min-height="64px"
            width="55%"
            border-width="0px 0px 1px 0px "
            md-width="100%"
            border-style="solid"
            margin="0px 74px 0px 0px"
            md-margin="0px 32px 30px 0px"
          >
            <Image
              src="/index/kcrop.jpg"
              width="100%"
              object-fit="cover"
              margin="0px 0px 40px 0px"
              max-height="288px"
              object-position="50% 50%"
              lg-min-height="308px"
              md-margin="0px 0px 0px 0px"
              sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
            />
          </Box>
          <Box
            empty-border-color="LightGray"
            width="45%"
            border-width="0px 0px 1px 0px "
            border-style="solid"
            border-color="rgba(224, 89, 119, 0.5)"
            empty-min-width="64px"
            empty-min-height="64px"
            empty-border-width="1px"
            empty-border-style="solid"
            padding="0px 0px 0px 0px"
            md-width="100%"
          >
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Koně
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--darkL2">
              Pohladí po duši a zanechají nezapomenutelné chvíle
            </Text>
            <Text color="--darkL2" lg-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif" margin="0px 0px 40px 0px" font="--lead">
              Koně jsou krásná zvířata. My chováme dvě kobylky plemena český teplokrevník. O radost z nich se s Vámi rádi podělíme. Pokud nás přijedete navštívit, rádi Vám nabídneme menší, nebo větší projížďku.
            </Text>
          </Box>
        </Box>
        <Box
          empty-border-style="solid"
          empty-border-color="LightGray"
          display="flex"
          margin="0px 0px 64px 0px"
          md-flex-direction="column"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
        >
          <Box
            empty-border-width="1px"
            empty-border-style="solid"
            border-color="rgba(224, 89, 119, 0.5)"
            lg-margin="0px 32px 0px 0px"
            empty-border-color="LightGray"
            md-border-style="none"
            empty-min-width="64px"
            empty-min-height="64px"
            width="55%"
            border-width="0px 0px 1px 0px "
            md-width="100%"
            border-style="solid"
            margin="0px 74px 0px 0px"
            md-margin="0px 32px 30px 0px"
          >
            <Image
              src="/index/dcrop.JPG"
              width="100%"
              object-fit="cover"
              margin="0px 0px 40px 0px"
              max-height="288px"
              object-position="50% 50%"
              lg-min-height="308px"
              md-margin="0px 0px 0px 0px"
              sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
            />
          </Box>
          <Box
            empty-border-color="LightGray"
            width="45%"
            border-width="0px 0px 1px 0px "
            border-style="solid"
            border-color="rgba(224, 89, 119, 0.5)"
            empty-min-width="64px"
            empty-min-height="64px"
            empty-border-width="1px"
            empty-border-style="solid"
            padding="0px 0px 0px 0px"
            md-width="100%"
          >
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Daňci
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--darkL2">
              Krásná zvířata s luxusním masem
            </Text>
            <Text color="--darkL2" lg-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif" margin="0px 0px 40px 0px" font="--lead">
              Jen stěží najdete krásnější zvířata, než jsou daňci. U nás je najdete ve velkém výběhu, kde najdou klid, přístřeší i volný pohyb po pastvě. Daňky můžete lehce vidět na pastvě z naší chaty. Navíc jsou daňci výborným zdrojem kvalitní zvěřiny s vynikající chutí.
            </Text>
          </Box>
        </Box>
        <Box
          empty-border-style="solid"
          empty-border-color="LightGray"
          display="flex"
          margin="0px 0px 64px 0px"
          md-flex-direction="column"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
        >
          <Box
            empty-border-width="1px"
            empty-border-style="solid"
            border-color="rgba(224, 89, 119, 0.5)"
            lg-margin="0px 32px 0px 0px"
            empty-border-color="LightGray"
            md-border-style="none"
            empty-min-width="64px"
            empty-min-height="64px"
            width="55%"
            border-width="0px 0px 1px 0px "
            md-width="100%"
            border-style="solid"
            margin="0px 74px 0px 0px"
            md-margin="0px 32px 30px 0px"
          >
            <Image
              src="/index/ocrop.JPG"
              width="100%"
              object-fit="cover"
              margin="0px 0px 40px 0px"
              max-height="288px"
              object-position="50% 50%"
              lg-min-height="308px"
              md-margin="0px 0px 0px 0px"
              sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
            />
          </Box>
          <Box
            empty-border-color="LightGray"
            width="45%"
            border-width="0px 0px 1px 0px "
            border-style="solid"
            border-color="rgba(224, 89, 119, 0.5)"
            empty-min-width="64px"
            empty-min-height="64px"
            empty-border-width="1px"
            empty-border-style="solid"
            padding="0px 0px 0px 0px"
            md-width="100%"
          >
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Ovce vřesová
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--darkL2">
              Staré plemeno s chutí zvěřiny
            </Text>
            <Text color="--darkL2" lg-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif" margin="0px 0px 40px 0px" font="--lead">
              Ovce jsou užitečná hospodářská zvířata, která u nás našla místo v okolí rybníků, kde odvádí výbornou službu a pomáhají s údržbou krajiny. Chováme stádečko plemena ovce vřesová, která okouzlí chutí masa, které je velmi podobné zvěřině. Může za to její přímá příbuznost s muflonem, která se promítá také v samostatnosti plemena a bezproblémovosti chovu. Díky tomu zůstávají zvířata vitální i bez nutných zásahů do přirozeného života.
            </Text>
          </Box>
        </Box>
        <Box
          md-flex-direction="column"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          display="flex"
          margin="0px 0px 0px 0px"
        >
          <Box
            empty-min-width="64px"
            empty-border-color="LightGray"
            border-color="rgba(224, 89, 119, 0.5)"
            md-width="100%"
            empty-min-height="64px"
            empty-border-width="1px"
            empty-border-style="solid"
            width="55%"
            border-width="0px 0px 1px 0px "
            border-style="solid"
            margin="0px 74px 0px 0px"
            lg-margin="0px 32px 0px 0px"
            md-margin="0px 32px 30px 0px"
            md-border-style="none"
          >
            <Image
              width="100%"
              object-fit="cover"
              margin="0px 0px 40px 0px"
              max-height="288px"
              object-position="50% 50%"
              lg-min-height="308px"
              md-margin="0px 0px 0px 0px"
              src="/index/vcrop.jpg"
              sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
            />
          </Box>
          <Box
            empty-border-width="1px"
            empty-border-style="solid"
            border-style="solid"
            md-width="100%"
            padding="0px 0px 0px 0px"
            border-width="0px 0px 1px 0px "
            border-color="rgba(224, 89, 119, 0.5)"
            empty-min-width="64px"
            empty-min-height="64px"
            empty-border-color="LightGray"
            width="45%"
          >
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Včely
            </Text>
            <Text color="--darkL2" margin="0px 0px 16px 0px" font="--base">
              Pracují, aby příroda kvetla
            </Text>
            <Text margin="0px 0px 40px 0px" font="--lead" color="--darkL2" lg-font="normal 400 16px/1.5 &quot;Marcellus&quot;, serif">
              Med je dar přírody. V naší rodině se včelaření dědí z generace na generaci již přes 100 let. Nyní u nás najdete dvacet včelstev, která jsou umístěna na vhodném místě, které kombinuje pro včely to nejlepší. V okolí včely nacházejí různorodá kvetoucí pole i hluboké lesy. Dokáží tak přinést ty nejlepší suroviny pro kvalitní med. Můžeme Vám nabídnout směsný med louka, les a také mes květový pastovaný. Pastování je šetrná metoda, díky které med zachová tekutou strukturu a neztuhne. Spočívá pouze v míchání medu ve vhodnou dobu. Nedochází tak k dalším změnám, které by mohly med poškodit. Vřele doporučujeme pastovaný med zkusit.
            </Text>
          </Box>
        </Box>
      </Box>
    </Section>
    {/*
    <Section padding="70px 0 140px 0" md-padding="20px 0 70px 0" background="--color-sectionBg">
      <Override slot="SectionContent" md-grid-template-columns="1fr" display="grid" grid-template-columns="1fr 1fr" />
      <Box
        empty-border-style="solid"
        empty-border-color="LightGray"
        grid-column="1 / span 2"
        md-grid-column="auto / auto"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
      >
        <Text
          sm-width="100%"
          md-width="100%"
          font="--lead"
          color="--green"
          margin="0px 0px 20px 0px"
          lg-font="normal 400 14px/1.5 &quot;Marcellus&quot;, serif"
          lg-width="50%"
          lg-margin="0px 0px 16px 0px"
        >
          Chcete si dopřát to nejlepší?
        </Text>
        <Text
          color="--primary"
          lg-font="normal 500 32px/1.3 &quot;Marcellus&quot;, serif"
          sm-width="100%"
          font="--headline2"
          margin="0px 0px 24px 0px"
          width="100%"
          sm-font="normal 500 28px/1.3 &quot;Marcellus&quot;, serif"
          sm-margin="0px 0px 0px 0px"
          md-width="100%"
          md-margin="0px 0px 0px 0px"
        >
          Plody z našeho dvora
        </Text>
      </Box>
      <Box
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
      >
        <Box
          display="flex"
          sm-border-style="none"
          sm-flex-direction="column"
          md-border-width="0px"
          border-style="solid"
          margin="8px 0px 8px 0px"
          lg-padding="2px 4% 2px 0px"
          border-width="0px 0.5px 0px 0px"
          border-color="rgba(224, 89, 119, 0.5)"
          md-padding="32px 0px 32px 0px"
          lg-min-height="320px"
          padding="2px 14% 2px 0px"
          sm-padding="32px 0px 32px 0px"
          md-border-style="none"
          min-height="260px"
          align-items="center"
        >
          <Image
            sm-margin="0px 0px 24px 0px"
            margin="0px 35px 0px 0px"
            height="200px"
            sm-width="100%"
            sm-min-height="336px"
            md-margin="0px 24px 0px 0px"
            src="https://images.unsplash.com/photo-1557555187-23d685287bc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=364&q=80"
            width="167px"
            object-fit="cover"
            lg-margin="0px 16px 0px 0px"
            srcSet="https://images.unsplash.com/photo-1557555187-23d685287bc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80 500w,https://images.unsplash.com/photo-1557555187-23d685287bc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80 800w,https://images.unsplash.com/photo-1557555187-23d685287bc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1080&q=80 1080w,https://images.unsplash.com/photo-1557555187-23d685287bc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1600&q=80 1600w,https://images.unsplash.com/photo-1557555187-23d685287bc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2000&q=80 2000w,https://images.unsplash.com/photo-1557555187-23d685287bc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2600&q=80 2600w,https://images.unsplash.com/photo-1557555187-23d685287bc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3200&q=80 3200w"
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Box width="70%" lg-width="80%" sm-width="100%">
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Med
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--coralD1" />
            <Text margin="0px 0px 0px 0px" font="--lead" color="--darkL2">
              She is our fearless leader! She founded our studio in 2009, from a laptop at her kitchen table, with only a love of photography and weddings and a whole lot of determination.
            </Text>
          </Box>
        </Box>
        <Hr
          padding="0px 0px 0px 0px"
          sm-margin="0px 0px 0px 0px"
          sm-padding="0px 0px 0px 0px"
          sm-width="100%"
          sm-display="none"
          md-margin="0px 0px 0px 0px"
          md-width="100%"
          md-padding="0px 0px 0px 0px"
          width="98%"
          border-color="rgba(224, 89, 119, 0.5)"
          margin="0px 2% 0px 0px"
        />
      </Box>
      <Box
        empty-border-style="solid"
        empty-border-color="LightGray"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
      >
        <Box
          align-items="center"
          display="flex"
          md-border-style="none"
          border-style="solid"
          min-height="260px"
          md-padding="32px 0px 32px 0px"
          lg-padding="2px 2% 2px 2%"
          sm-padding="32px 0px 32px 0px"
          sm-flex-direction="column"
          border-color="rgba(224, 89, 119, 0.5)"
          margin="8px 0px 8px 0px"
          sm-border-style="none"
          md-border-width="0px"
          lg-min-height="320px"
          padding="2px 7% 2px 7%"
          border-width="0px 0px 0px 0.5px"
        >
          <Image
            sm-margin="0px 0px 24px 0px"
            src="https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80"
            width="167px"
            margin="0px 35px 0px 0px"
            height="200px"
            lg-margin="0px 16px 0px 0px"
            sm-width="100%"
            sm-min-height="336px"
            md-margin="0px 24px 0px 0px"
            object-fit="cover"
            srcSet="https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80 500w,https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80 800w,https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1080&q=80 1080w,https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80 1600w,https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80 2000w,https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2600&q=80 2600w,https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3200&q=80 3200w"
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Box lg-width="80%" sm-width="100%" width="70%">
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Jehněčí maso
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--coralD1" />
            <Text margin="0px 0px 0px 0px" font="--lead" color="--darkL2">
              She has been a pineapple for almost four years, has a knack for seeing the quiet moment within a big scene, and will giggle like a 4-year-old if you give her funny socks.
            </Text>
          </Box>
        </Box>
        <Hr
          md-width="100%"
          md-padding="0px 0px 0px 0px"
          margin="0px 0px 0px 2%"
          sm-width="100%"
          sm-margin="0px 0px 0px 0px"
          sm-padding="0px 0px 0px 0px"
          md-margin="0px 0px 0px 0px"
          width="98%"
          border-color="rgba(224, 89, 119, 0.5)"
          padding="0px 0px 0px 0px"
          sm-display="none"
        />
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        empty-min-width="64px"
        empty-min-height="64px"
      >
        <Box
          border-color="rgba(224, 89, 119, 0.5)"
          sm-flex-direction="column"
          min-height="260px"
          align-items="center"
          lg-min-height="320px"
          md-border-width="0px"
          md-border-style="none"
          padding="2px 14% 2px 0px"
          border-width="0px 0.5px 0px 0px"
          border-style="solid"
          margin="8px 0px 8px 0px"
          md-padding="32px 0px 32px 0px"
          display="flex"
          lg-padding="2px 4% 2px 0px"
          sm-border-style="none"
          sm-padding="32px 0px 32px 0px"
        >
          <Image
            sm-min-height="336px"
            width="167px"
            object-fit="cover"
            margin="0px 35px 0px 0px"
            height="200px"
            lg-margin="0px 16px 0px 0px"
            sm-width="100%"
            sm-margin="0px 0px 24px 0px"
            md-margin="0px 24px 0px 0px"
            src="https://images.unsplash.com/photo-1464863979621-258859e62245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=386&q=80"
            srcSet="https://images.unsplash.com/photo-1464863979621-258859e62245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80 500w,https://images.unsplash.com/photo-1464863979621-258859e62245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80 800w,https://images.unsplash.com/photo-1464863979621-258859e62245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1080&q=80 1080w,https://images.unsplash.com/photo-1464863979621-258859e62245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1600&q=80 1600w,https://images.unsplash.com/photo-1464863979621-258859e62245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2000&q=80 2000w,https://images.unsplash.com/photo-1464863979621-258859e62245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2600&q=80 2600w,https://images.unsplash.com/photo-1464863979621-258859e62245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3200&q=80 3200w"
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Box width="70%" lg-width="80%" sm-width="100%">
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Dančí maso
            </Text>
            <Text color="--coralD1" margin="0px 0px 16px 0px" font="--base" />
            <Text font="--lead" color="--darkL2" margin="0px 0px 0px 0px">
              Elisabeth's natural state is cheerfulness, and she breathes life into the room whenever she walks in. Mustard is her signature color, but she hates eating it.
            </Text>
          </Box>
        </Box>
        <Hr
          sm-width="100%"
          sm-margin="0px 0px 0px 0px"
          sm-display="none"
          margin="0px 2% 0px 0px"
          padding="0px 0px 1px 0px"
          border-color="rgba(224, 89, 119, 0.5)"
          sm-padding="0px 0px 0px 0px"
          md-margin="0px 0px 0px 0px"
          md-width="100%"
          md-padding="0px 0px 0px 0px"
          width="98%"
        />
      </Box>
      <Box
        empty-border-style="solid"
        empty-border-color="LightGray"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
      >
        <Box
          padding="2px 7% 2px 7%"
          sm-border-style="none"
          sm-padding="32px 0px 32px 0px"
          md-border-style="none"
          align-items="center"
          sm-flex-direction="column"
          md-border-width="0px"
          display="flex"
          border-width="0px 0px 0px 0.5px"
          border-color="rgba(224, 89, 119, 0.5)"
          margin="8px 0px 8px 0px"
          lg-padding="2px 2% 2px 2%"
          md-padding="32px 0px 32px 0px"
          border-style="solid"
          min-height="260px"
          lg-min-height="320px"
        >
          <Image
            sm-margin="0px 0px 24px 0px"
            src="https://images.unsplash.com/photo-1601288848351-48adce9d676a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80"
            width="167px"
            object-fit="cover"
            margin="0px 35px 0px 0px"
            height="200px"
            lg-margin="0px 16px 0px 0px"
            sm-width="100%"
            sm-min-height="336px"
            md-margin="0px 24px 0px 0px"
            srcSet="https://images.unsplash.com/photo-1601288848351-48adce9d676a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80 500w,https://images.unsplash.com/photo-1601288848351-48adce9d676a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80 800w,https://images.unsplash.com/photo-1601288848351-48adce9d676a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1080&q=80 1080w,https://images.unsplash.com/photo-1601288848351-48adce9d676a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80 1600w,https://images.unsplash.com/photo-1601288848351-48adce9d676a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80 2000w,https://images.unsplash.com/photo-1601288848351-48adce9d676a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2600&q=80 2600w,https://images.unsplash.com/photo-1601288848351-48adce9d676a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3200&q=80 3200w"
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Box width="70%" lg-width="80%" sm-width="100%">
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Jehňata na výpas
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--coralD1" />
            <Text margin="0px 0px 0px 0px" font="--lead" color="--darkL2">
              Meet Madelaine! She has an oil for everything, is a real empath, and meticulously inspects and cleans all of her equipment before every wedding.
            </Text>
          </Box>
        </Box>
        <Hr
          sm-display="none"
          md-padding="0px 0px 0px 0px"
          width="98%"
          padding="0px 0px 0px 0px"
          sm-width="100%"
          sm-margin="0px 0px 0px 0px"
          sm-padding="0px 0px 0px 0px"
          border-color="rgba(224, 89, 119, 0.5)"
          margin="0px 0px 0px 2%"
          md-margin="0px 0px 0px 0px"
          md-width="100%"
        />
      </Box>
      <Box
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
      >
        <Box
          md-padding="32px 0px 32px 0px"
          lg-min-height="320px"
          padding="2px 14% 2px 0px"
          margin="8px 0px 8px 0px"
          md-border-style="none"
          min-height="260px"
          align-items="center"
          border-width="0px 0.5px 0px 0px"
          lg-padding="2px 4% 2px 0px"
          sm-flex-direction="column"
          sm-padding="32px 0px 32px 0px"
          md-border-width="0px"
          display="flex"
          border-style="solid"
          border-color="rgba(224, 89, 119, 0.5)"
          sm-border-style="none"
        >
          <Image
            src="https://images.unsplash.com/photo-1592214534258-0067435006d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
            width="167px"
            sm-width="100%"
            object-fit="cover"
            margin="0px 35px 0px 0px"
            height="200px"
            lg-margin="0px 16px 0px 0px"
            sm-min-height="336px"
            sm-margin="0px 0px 24px 0px"
            md-margin="0px 24px 0px 0px"
            srcSet="https://images.unsplash.com/photo-1592214534258-0067435006d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80 500w,https://images.unsplash.com/photo-1592214534258-0067435006d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80 800w,https://images.unsplash.com/photo-1592214534258-0067435006d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1080&q=80 1080w,https://images.unsplash.com/photo-1592214534258-0067435006d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1600&q=80 1600w,https://images.unsplash.com/photo-1592214534258-0067435006d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2000&q=80 2000w,https://images.unsplash.com/photo-1592214534258-0067435006d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2600&q=80 2600w,https://images.unsplash.com/photo-1592214534258-0067435006d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3200&q=80 3200w"
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Box width="70%" lg-width="80%" sm-width="100%">
            <Text margin="0px 0px 0px 0px" font="--headline3" color="--green">
              Hovězí maso
            </Text>
            <Text margin="0px 0px 16px 0px" font="--base" color="--coralD1" />
            <Text font="--lead" color="--darkL2" margin="0px 0px 0px 0px">
              Meet Rachel! She loves pasta, her poodle, and claims she can't cook. When making a decision, she is careful and deliberate, and she spots beauty in the moments between poses.
            </Text>
          </Box>
        </Box>
        <Hr
          padding="0px 0px 1px 0px"
          border-color="rgba(224, 89, 119, 0.5)"
          sm-width="100%"
          sm-margin="0px 0px 0px 0px"
          sm-display="none"
          md-margin="0px 0px 0px 0px"
          md-width="100%"
          width="98%"
          sm-padding="0px 0px 0px 0px"
          md-padding="0px 0px 0px 0px"
          margin="0px 2% 0px 0px"
        />
      </Box>
      <Box
        empty-border-style="solid"
        empty-border-color="LightGray"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
      >
        <Box
          border-width="0px 0px 0px 0.5px"
          sm-border-style="none"
          align-items="center"
          border-color="rgba(224, 89, 119, 0.5)"
          width="100%"
          border-style="solid"
          sm-padding="32px 0px 32px 0px"
          md-min-height="200px"
          lg-min-height="320px"
          display="flex"
          justify-content="center"
          md-border-width="0px"
          md-border-style="none"
          margin="8px 0px 8px 0px"
          max-height="260px"
          height="100%"
        >
          <Image
            width="96px"
            height="96px"
            src="https://uploads.quarkly.io/615c316435c5c8001f775568/images/icon-park-outline_cross-ring-two.png?v=2021-10-06T07:55:36.055Z"
            srcSet="https://smartuploads.quarkly.io/615c316435c5c8001f775568/images/icon-park-outline_cross-ring-two.png?v=2021-10-06T07%3A55%3A36.055Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/615c316435c5c8001f775568/images/icon-park-outline_cross-ring-two.png?v=2021-10-06T07%3A55%3A36.055Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/615c316435c5c8001f775568/images/icon-park-outline_cross-ring-two.png?v=2021-10-06T07%3A55%3A36.055Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/615c316435c5c8001f775568/images/icon-park-outline_cross-ring-two.png?v=2021-10-06T07%3A55%3A36.055Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/615c316435c5c8001f775568/images/icon-park-outline_cross-ring-two.png?v=2021-10-06T07%3A55%3A36.055Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/615c316435c5c8001f775568/images/icon-park-outline_cross-ring-two.png?v=2021-10-06T07%3A55%3A36.055Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/615c316435c5c8001f775568/images/icon-park-outline_cross-ring-two.png?v=2021-10-06T07%3A55%3A36.055Z&quality=85&w=3200 3200w"
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
        </Box>
        <Hr
          md-padding="0px 0px 0px 0px"
          width="98%"
          border-color="rgba(224, 89, 119, 0.5)"
          sm-display="none"
          sm-margin="0px 0px 0px 0px"
          sm-padding="0px 0px 0px 0px"
          md-margin="0px 0px 0px 0px"
          md-width="100%"
          padding="0px 0px 1px 0px"
          margin="0px 0px 0px 2%"
          sm-width="100%"
        />
      </Box>
    </Section> */}

    <Section id="galerie">
      <Text
        sm-text-align="center"
        sm-font="normal 500 28px/1.3 &quot;Marcellus&quot;, serif"
        md-font="normal 500 28px/1.3 &quot;Marcellus&quot;, serif"
        margin="0px 0px 20px 0px"
        font="--headline2"
        color="--green"
      >
        Galerie
      </Text>

      <Gallery />

    </Section>
    <Components.QuarklycommunityKitNetlifyForm />
    <Section id="kontakty" padding="80px 0 90px 0" quarkly-title="Contacts-5">
      <Override slot="SectionContent" align-items="center" />
      <Text
        lg-padding="0px 0px 0px 0px"
        sm-font="normal 700 36px/1.2 --fontFamily-sans"
        margin="0px 0px 18px 0px"
        font="--headline1"
        color="--primary"
        text-align="center"
        padding="0px 0 0px 0px"
        lg-width="100%"
        lg-margin="0px 0px 25px 0px"
      >
        Ozvěte se nám
      </Text>
      <Box
        min-width="100px"
        min-height="100px"
        display="grid"
        grid-template-columns="repeat(3, 1fr)"
        grid-gap="16px 24px"
        margin="0px 0px 80px 0px"
        md-margin="0px 0px 50px 0px"
        lg-grid-template-columns="repeat(2, 1fr)"
        sm-grid-template-columns="1fr"
        order="0"
        flex="0 1 auto"
        justify-items="center"
        justify-content="center"
      >
        <Box
          min-width="100px"
          min-height="100px"
          display="flex"
          flex-direction="column"
          align-items="center"
          padding="36px 20px 20px 20px"
          border-width="1px"
          border-style="solid"
          border-color="--color-lightD2"
          border-radius="4px"
        >
          <Icon
            category="bs"
            icon={BsPhone}
            size="36px"
            margin="0px 0px 20px 0px"
            color="--primary"
          />
          <Text
            margin="0px 0px 15px 0px"
            font="normal 500 24px/1.2 --fontFamily-sansHelvetica"
            text-align="center"
            color="--primary"
            md-margin="0px 0px 20px 0px"
          >
            Telefon
          </Text>
          <Link
            href="tel:+420773036698"
            color="#47474d"
            text-decoration-line="initial"
            font="normal 300 18px/1.5 --fontFamily-sansHelvetica"
            display="block"
            text-align="center"
            margin="0px 0px 15px 0px"
          >
            773 036 698
          </Link>
        </Box>
        <Box
          min-width="100px"
          min-height="100px"
          display="flex"
          flex-direction="column"
          align-items="center"
          padding="36px 20px 20px 20px"
          border-width="1px"
          border-style="solid"
          border-color="--color-lightD2"
          border-radius="4px"
        >
          <Icon
            category="bs"
            icon={BsEnvelope}
            size="36px"
            margin="0px 0px 20px 0px"
            color="--primary"
          />
          <Text
            margin="0px 0px 15px 0px"
            font="normal 500 24px/1.2 --fontFamily-sansHelvetica"
            text-align="center"
            color="--primary"
            md-margin="0px 0px 20px 0px"
          >
            E-mail
          </Text>
          <Link
            href="mailto:info@dvurumlyna.cz"
            color="#47474d"
            text-decoration-line="initial"
            font="normal 300 18px/1.5 --fontFamily-sansHelvetica"
            display="block"
            margin="0px 0px 15px 0px"
            text-align="center"
          >
            info@dvurumlyna.cz
          </Link>
        </Box>
        <Box
          min-width="100px"
          min-height="100px"
          display="flex"
          flex-direction="column"
          align-items="center"
          padding="36px 20px 20px 20px"
          border-width="1px"
          border-style="solid"
          border-color="--color-lightD2"
          border-radius="4px"
        >
          <Icon
            category="bs"
            icon={BsMap}
            size="36px"
            margin="0px 0px 20px 0px"
            color="--primary"
          />
          <Text
            margin="0px 0px 15px 0px"
            font="normal 500 24px/1.2 --fontFamily-sansHelvetica"
            text-align="center"
            color="--primary"
            md-margin="0px 0px 20px 0px"
          >
            Adresa
          </Text>
          <Text
            margin="0px 0px 20px 0px"
            color="#47474d"
            font="normal 300 18px/1.5 --fontFamily-sansHelvetica"
            text-align="center"
            border-color="#b8acac"
            md-margin="0px 0px 15px 0px"
          >
            Osová Bítýška 25
            <br />
            594 53 Osová Bítýška
          </Text>
        </Box>
      </Box>
    </Section>
  </Theme>;
});
